export const HISTORY_LOGS_PAGE = 1;
export const HISTORY_LOGS_COUNT_PER_PAGE = 50;
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
